// ----------------------------------------------------------------------------
// Функции помогают работать с паролями
// ----------------------------------------------------------------------------



import {accountElements, authAccountElements, authElements} from "./auth-account-elements.js";
import {removeElements} from "./auth-misc-functions.js";
import ttLKScrollToMessage from "../account/tt-LK-scroll-to-message.js";
import {hideElement, showElement} from "../visibility/showHide.js";



/**
 * Функция очищает поля смены паролей и прячет весь контейнер
 * а также возвращает видимой ссылку сменить пароль
 *
 * @return {void}
 */
export const closePasswordForm = () => {
    if (accountElements.changePassword) accountElements.changePassword.style.display = '';
    accountElements.changePasswordFields.forEach((field) => field.style.display = 'none');

    if (authAccountElements.ttAuthPasswordOld) authAccountElements.ttAuthPasswordOld.value = '';
    if (authAccountElements.ttAuthPasswordNew) authAccountElements.ttAuthPasswordNew.value = '';
    if (authAccountElements.ttAuthPassword) authAccountElements.ttAuthPassword.value = '';
}

/**
 *
 * @param id
 * @param hc
 */
export const passwordRenewSuccess = (id, hc) => {
    document.location.href = '/myaccount/?TTUser=' + id + '&TTUserConfirmP=' + hc;
}

/**
 * Скрывает ссылку "сменить пароль" и показывает поля для ввода старого и нового паролей
 * @returns {void}
 */
export function ttAuthPasswordShow() {
    if (accountElements.changePassword) accountElements.changePassword.style.display = 'none';
    accountElements.changePasswordFields.forEach((field) => field.style.display = '');
}


/**
 * Обрабатывает событие формы изменения пароля, отправляя данные на сервер.
 *
 * @param {Event} [e] - Объект события (например, submit или click).
 * @returns {boolean} Всегда возвращает false для блокировки стандартного поведения.
 */
export async function ttChangePassword(e) {
    e?.preventDefault();

    const { accountHeader } = accountElements || {};
    const { ttAuthPassword, ttAuthPasswordNew, ttAuthPasswordOld } = authAccountElements || {};

    // Вспомогательная функция для вывода сообщений
    const showMessage = (text, modifier = '') => {
        removeElements('.g-message');
        if (!accountHeader) return;

        const className = modifier ? `g-message g-message--${modifier}` : 'g-message';

        accountHeader.insertAdjacentHTML('afterend', `<div class="${className}">${text}</div>`);
    };

    // Проверка наличия элементов и их значений
    if (!ttAuthPassword?.value || !ttAuthPasswordOld?.value || !ttAuthPasswordNew?.value) {
        showMessage('Заполните поля старого и нового пароля.', 'error');
        ttLKScrollToMessage();
        return false;
    }

    showMessage('Обработка данных...');

    try {
        const response = await fetch('/oauth/get_data.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: new URLSearchParams({
                password: ttAuthPassword.value,
                password_new: ttAuthPasswordNew.value,
                password_old: ttAuthPasswordOld.value,
            })
        });

        if (!response.ok) {
            console.error('Сетевая ошибка сервера, статус:', response.status);
            showMessage('Ошибка сети. Проверьте подключение и попробуйте снова.', 'error');
            ttLKScrollToMessage();
            return false;
        }

        const data = await response.json();

        if (Number(data.RES) === 1) {
            showMessage(data.MSG, 'ok');
            closePasswordForm();
            ttLKScrollToMessage(1);
        } else if (data.ERROR) {
            showMessage(data.ERROR, 'error');
            ttLKScrollToMessage();
        } else {
            showMessage('Действие не удалось. Попробуйте позже.', 'error');
            ttLKScrollToMessage();
        }

    } catch (error) {
        console.error('Произошла ошибка при отправке:', error);
        // Снимаем лоадер и показываем ошибку пользователю, если запрос упал
        showMessage('Ошибка сети. Проверьте подключение и попробуйте снова.', 'error');
        ttLKScrollToMessage();
    }

    return false;
}



/**
 * Обрабатывает запрос на восстановление пароля, отправляя данные на сервер.
 * @param {Event} [e] - Объект события клика.
 * @returns {boolean} Всегда возвращает false для блокировки стандартного поведения.
 */
export const ttAuthPasswordRenew = async (e) => {
    e?.preventDefault();
    removeElements('.g-message');

    const authContainer = authElements.authRegistration;
    const emailInput = authElements.ttAuthEmail;
    const emailValue = emailInput?.value?.trim();

    /**
     * Вспомогательная функция для вывода сообщений.
     * @param {string} msg - Текст сообщения (должен быть экранирован, если получен извне).
     * @param {string} [type=''] - Тип сообщения ('ok', 'error' или пусто для инфо).
     */
    const showMessage = (msg, type = '') => {
        const typeClass = type ? ` g-message--${type}` : '';
        authContainer.insertAdjacentHTML('beforeend', `<div class="g-message${typeClass}">${msg}</div>`);
    };

    if (emailValue && emailValue.length > 0) {
        showMessage('Обработка данных...');

        const data = new URLSearchParams({
            sendpasswordlink: window.PassConfig.passwordLinkToken,
            email: emailValue
        });

        try {
            const response = await fetch('/oauth/get_data.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: data,
            });

            if (!response.ok) {
                console.error('Сетевая ошибка сервера, статус:', response.status);
                removeElements('.g-message');
                showMessage('Ошибка соединения. Проверьте интернет.', 'error');
                return false;
            }

            const responseData = await response.json();
            removeElements('.g-message');

            if (Number(responseData.RES) === 1) {
                // Экранируем данные, пришедшие от сервера
                showMessage(responseData.MSG, 'ok');
            } else if (responseData.ERROR) {
                showMessage(responseData.ERROR, 'error');
            } else {
                showMessage('Отправить ссылку не удалось. Попробуйте позже.', 'error');
            }

        } catch (error) {
            console.error('Произошла ошибка: ' + error);
            removeElements('.g-message');
            showMessage('Ошибка соединения. Проверьте интернет.', 'error');
        }
    } else {
        showMessage('Укажите адрес электронной почты, на который зарегистрирована ваша учетная запись.', 'error');
    }

    return false;
}


/**
 * Переводит форму авторизации в режим установки нового пароля.
 * Обновляет заголовки, скрывает неиспользуемые поля (имя, аватар, email, капча)
 * и отображает поля для ввода нового пароля. Добавляет скрытые инпуты с токенами пользователя.
 *
 * @returns {void}
 */
export const ttAuthPasswordRenewForm = () => {
    if (authElements.ttAuthHiddenField) authElements.ttAuthHiddenField.value = 'edit';

    authElements.ttAuthForm?.insertAdjacentHTML(
        'beforeend',
        '<input type="hidden" name="TTUser" value="' + window.TTUser + '"><input type="hidden" name="TTUserConfirmPR" value="' + window.TTUserConfirmPR + '">'
    );

    const h1 = document.querySelector('.auth-header h1');
    if (h1) h1.textContent = 'Установка нового пароля';

    if (authElements.ttAuthBtn) {
        authElements.ttAuthBtn.value = 'Сохранить';
        authElements.ttAuthBtn.disabled = false;
    }
    if (authElements.ttAuthAva) authElements.ttAuthAva.value = '';

    if (authElements.ttAuthName) {
        authElements.ttAuthName.readOnly = true;
        authElements.ttAuthName.value = '';
    }
    //if (accountElementsObject.ttAuthNameTxt) accountElementsObject.ttAuthNameTxt.textContent = '';

    //hideElement(accountElementsObject.ttAuthNameDiv);
    hideElement(authElements.ttAuthNameTxtDiv);
    hideElement(authElements.ttAuthAvaDiv);
    hideElement(authElements.ttAuthCapDiv);

    if (authElements.ttAuthEmail) authElements.ttAuthEmail.value = '';
    hideElement(authElements.ttAuthEmail);

    if (authAccountElements.ttAuthPassword) authAccountElements.ttAuthPassword.value = '';
    if (authAccountElements.ttAuthPasswordNew) authAccountElements.ttAuthPasswordNew.value = '';
    showElement(authAccountElements.ttAuthPasswordNew);
    showElement(authAccountElements.ttAuthPassword);

    hideElement(document.querySelector('.footer-link--remindme'));

    const h3 = document.querySelector('.auth-registration-wrapper h3');
    if (h3) h3.innerHTML = '<span class="pseudolink--dotted active">Установка нового пароля</span>';
}